import * as React from 'react'
import { Table } from 'reactstrap'
import * as DataService from '../../services/DataService';
import { accentUtils, format } from '../../services/HelperService';

import { InstallTimeBadge } from './InstallTimeBadge'
import { AccentSpinner } from '../AccentSpinner'

const query_BookCheckMeasureContactInfo = DataService.queryNoTracking("BookCheckMeasureContactInfo", undefined, true);


export class CalendarCheckMeasureCtrl extends React.Component {

    constructor(props) {
        super(props);


        this.state = {
            data: null
        };


        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {

        var me = this;

        query_BookCheckMeasureContactInfo.getFirstOrDefault({
            ID: this.props.id,
            LineFilter: (accentUtils.isNull(this.props.lineFilter) ? null : this.props.lineFilter),
        }).then(function (r) {
            me.setState({ data: r });
        });

    }


    render() {

        if (this.state.data === null) return <AccentSpinner />;



        const cmDate = format.formatDate(this.state.data.CMData.length > 0 ? this.state.data.CMData[0].CM_Date : null);
        const cmBy = this.state.data.CMData.length > 0 ? this.state.data.CMData[0].CM_By : null;
        const estCm = accentUtils.isEmpty(this.state.data.EstCheckMeasureTime) ? null : this.state.data.EstCheckMeasureTime;
        const estInst = accentUtils.isEmpty(this.state.data.EstInstallTime) ? null : this.state.data.EstInstallTime;

        return <Table className="accentCalendarCheckMeasureCtrl">
            <tr>
                <td className="acc-cell-date" title={cmDate ?? ""}><label>CM Date: &nbsp;</label>{cmDate}</td>
                <td className="acc-cell-cmby" title={cmBy ?? ""}><label>CM By: &nbsp;</label>{cmBy}</td>
                <td className="acc-calendar-time-cell" title={estCm ? `${estCm} mins` : ""}><label>Est CM: &nbsp;</label><InstallTimeBadge EstInstallTime={estCm} hideEmpty={true} /></td>
                <td className="acc-calendar-time-cell" title={estInst ? `${estInst} mins` : ""}><label>Est Inst: &nbsp;</label><InstallTimeBadge EstInstallTime={estInst} hideEmpty={true} /></td>
                <td className="acc-cell-phone" title={this.state.data.Mobile ?? ""}><label>Mob: &nbsp;</label>{this.state.data.Mobile}</td>
                <td className="acc-cell-phone" title={this.state.data.WorkPhone ?? ""}><label>Work: &nbsp;</label>{this.state.data.WorkPhone}</td>
                <td className="acc-cell-phone" title={this.state.data.HomePhone ?? ""}><label>Home: &nbsp;</label>{this.state.data.HomePhone}</td>
                <td className="acc-cell-email" title={this.state.data.Email ?? ""}><label>Email: &nbsp;</label>{this.state.data.Email}</td>
                <td className="acc-cell-address" title={this.state.data.Address ?? ""}><label>Addr: &nbsp;</label>{this.state.data.Address}</td>
            </tr>
        </Table>;
    }
}

